// Asegúrate de que esta función esté calculando correctamente el total con IVA
export const calcularTotalConIVA = (total: number, iva: number): number => {
  return total + (total * iva / 100);
};
